import {
  Card,
  CardBody,
  Collapse,
  HStack,
  IconButton,
  Show,
  Text,
  useDisclosure,
} from "@chakra-ui/react";
import React from "react";
import Breadcrumb from "./Breadcrumb";
import { MdClose, MdMenu } from "react-icons/md";
import SidebarCard from "../components/sidebar/SidebarCard";
import { useTranslation } from "react-i18next";

/**
 * Renders a navbar component
 * 
 * @returns The navbar component
 */
const Navbar = () => {
  const { isOpen, onToggle } = useDisclosure();
  const { t } = useTranslation();

  return (
    <React.Fragment>
      <Card borderRadius={0}>
        <CardBody>
          <HStack gap={4} justifyContent={"space-between"}>
            <HStack flexWrap={"wrap"} gap={1}>
              <HStack gap={1}>
                <Text color={"black"} fontWeight={"bold"}>
                  {t("operator.title")}
                </Text>
              </HStack>
              <Text>
                {t("operator.subtitle")}
              </Text>
            </HStack>
            <Show above={"md"}>
              <Breadcrumb />
            </Show>
            <Show below={"md"}>
              <IconButton
                icon={isOpen ? <MdClose /> : <MdMenu />}
                onClick={onToggle}
                variant={"ghost"}
              />
            </Show>
          </HStack>
        </CardBody>
      </Card>
      <Show below={"md"}>
        <Collapse in={isOpen}>
          <SidebarCard>
            <Breadcrumb
              sx={{
                ol: {
                  flexWrap: "wrap",
                  gap: 2,
                  margin: 2,
                },
                li: {
                  width: "full",
                },
              }}
            />
          </SidebarCard>
        </Collapse>
      </Show>
    </React.Fragment>
  );
};

export default React.memo(Navbar);
